import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const getPickAndChoosePrice = async (productIds) => {
	try {
		const { data } = await ApiClient.GET('getPickAndChoosePrice', `?productIds=${productIds}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const toggleDesignHideFromBuyer = async (productId, isHideToBuyer) => {
	try {
		const { data } = await ApiClient.GET(
			'toggleBuyerVisibility',
			`/${productId}?isHideToBuyer=${isHideToBuyer}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
